var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col items-center border bg-grey-lightest p-6",class:{
    'md:flex-row md:text-left md:px-6': ! _vm.mobile,
}},[_c('img',{staticClass:"w-32",attrs:{"src":"/img/apiro-question.gif","alt":"Apiro has a question"}}),_vm._v(" "),_c('div',{staticClass:"flex-1 text-center  ",class:{
        'md:flex-row md:text-left md:px-6': ! _vm.mobile,
    }},[_c('h3',[_vm._v("Not sure what's right for you?")]),_vm._v(" "),_c('p',[_vm._v("This can all be pretty confusing. However we're only just a click away and can help you make the right decision by talking to our 24/7 Sales & Support Staff.")])]),_vm._v(" "),_c('div',{staticClass:"w-full",class:{
        'md:w-auto': ! _vm.mobile,
    }})])}
var staticRenderFns = []

export { render, staticRenderFns }